var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarOutcomponent = function SvgCalendarOutcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.375 5.25c-.219 0-.375.164-.375.328v7.11C0 13.425.656 14 1.5 14h11c.813 0 1.5-.574 1.5-1.313V5.579c0-.164-.188-.328-.375-.328H.375ZM14 4.047v-.984c0-.711-.688-1.313-1.5-1.313H11V.328C11 .164 10.812 0 10.625 0h-1.25C9.156 0 9 .164 9 .328V1.75H5V.328C5 .164 4.812 0 4.625 0h-1.25C3.156 0 3 .164 3 .328V1.75H1.5c-.844 0-1.5.602-1.5 1.313v.984c0 .191.156.328.375.328h13.25c.188 0 .375-.137.375-.328ZM23.606 9.083l-2.237 2.095.881.822L26 8.5 22.25 5l-.881.822 2.237 2.095H16v1.166h7.606Z",
    fill: "current"
  })));
};
export default SvgCalendarOutcomponent;